import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Button,
    Select,
    MenuItem,
    Paper,
    Box,
    TextField,
    TableContainer,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Switch,
    Tooltip,
    Chip,
    Stack,
    IconButton,
    Divider,
    CircularProgress,
    List,
    ListItemButton,
    ListItemText,
    useMediaQuery
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useNotification } from './context/NotificationContext';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SaveIcon from '@mui/icons-material/Save';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const G9_OPENER_URL = 'https://frek.cc/proxy/38.54.86.24:5000/expiry/4587964455';
const G9_UPDATE_PORTS_URL = 'https://frek.cc/proxy/38.54.86.24:6687/update-ports/g9';
const G9_CALL_STATUS_FILTER_KEY = 'g9_call_status_filter';
const G9_VISIBLE_COLUMNS_KEY = 'g9_visible_columns';
const G9_EXPIRY_BY_NUMBER_KEY = 'g9_expiry_by_number';
const G9_UPDATED_PORTS_KEY = 'g9_updated_ports';
const G9_EXPIRY_RETRY_MS = 5 * 60 * 1000;
const G9_DEFAULT_VISIBLE_COLUMNS = {
    account: true,
    number: true,
    bal: true,
    autoRefetchExpiredBal: true,
    description: true,
    metrics: true,
    time: true,
    actionSelect: true,
    actionReboot: true,
};
const G9_CHECKLIST_GROUPS = [{ key: 'g9', label: 'Goip9', value: '9' }];
const G9_IMEI_SMS_OPERATIONS = [
    { key: 'change-imei', label: 'C IMEI (All)' },
    { key: 'change-imei-no-sim', label: 'C IMEI (N-ALL)' },
    { key: 'enable-sms', label: 'Enable SMS' },
    { key: 'disable-sms', label: 'Disable SMS' },
    { key: 'send-ussd', label: 'Send USSD' },
    { key: 'both-on', label: 'Both Locker ON' },
    { key: 'on-sms-locker', label: 'SMS Locker ON' },
    { key: 'on-call-locker', label: 'Call Locker ON' },
    { key: 'both-off', label: 'Both Locker OFF' },
    { key: 'sms-auto-on', label: 'SMS Auto Test On' },
    { key: 'sms-auto-off', label: 'SMS Auto Test Off' },
    { key: 'update-cookie', label: 'Update Cookie' },
    { key: 'save-config', label: 'Save Config' },
    { key: 'reboot-gateway', label: 'Reboot Gateway' },
];
const G9_SIP_OPTIONS = [
    { key: '-0', label: 'Off Traffic' },
    { key: '0', label: 'Empty Account' },
    { key: '1', label: 'NCLI Route On' },
    { key: '1a', label: 'NCLI Route Accounts' },
    { key: 'CC1', label: 'CC1 On(E)' },
    { key: 'CC1A', label: 'CC1 Accounts(E)' },
    { key: 'CC2', label: 'CC2 On(Ea)' },
    { key: 'CC2A', label: 'CC2 Accounts(Ea)' },
    { key: 'CC3', label: 'CC3 On(F)' },
    { key: 'CC3A', label: 'CC3 Accounts(F)' },
    { key: 'CC4', label: 'CC4 On(Fa)' },
    { key: 'CC4A', label: 'CC4 Accounts(Fa)' },
    { key: 'CC5', label: 'CC5 On(Eb)' },
    { key: 'CC5A', label: 'CC5 Accounts(Eb)' },
    { key: 'CC6', label: 'CC6 On(Fb)' },
    { key: 'CC6A', label: 'CC6 Accounts(Fb)' },
    { key: 'CC7', label: 'CC7 On(Fc)' },
    { key: 'CC7A', label: 'CC7 Accounts(Fc)' },
    { key: 'CC8', label: 'CC8 On(Ec)' },
    { key: 'CC8A', label: 'CC8 Accounts(Ec)' },
    { key: 'CC9', label: 'CC9 On(Ed)' },
    { key: 'CC9A', label: 'CC9 Accounts(Ed)' },
    { key: 'CC10', label: 'CC10 On(Fd)' },
    { key: 'CC10A', label: 'CC10 Accounts(Fd)' },
    { key: 'CC11', label: 'CC11 On(Ee)' },
    { key: 'CC11A', label: 'CC11 Accounts(Ee)' },
    { key: 'CC12', label: 'CC12 On(Fe)' },
    { key: 'CC12A', label: 'CC12 Accounts(Fe)' },
    { key: 'CC13', label: 'CC13 On(Ef)' },
    { key: 'CC13A', label: 'CC13 Accounts(Ef)' },
    { key: 'CC14', label: 'CC14 On(Ff)' },
    { key: 'CC14A', label: 'CC14 Accounts(Ff)' },
];

const G9PortsBingo = () => {
    const { showNotification } = useNotification();
    const GOIP_NUMBER = 9;
    const [data, setData] = useState([]);
    const [monitorData, setMonitorData] = useState([]);
    const [sipData, setSipData] = useState([]);
    const [mediaData, setMediaData] = useState([]);
    const [portData, setPortData] = useState([]);
    const [smsStatusByPort, setSmsStatusByPort] = useState({});
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [activeActionLabel, setActiveActionLabel] = useState('');
    const [confirmDialogTitle, setConfirmDialogTitle] = useState('Confirm Action');
    const [confirmDialogMessage, setConfirmDialogMessage] = useState('Are you sure you want to proceed with this action?');
    const [pendingAction, setPendingAction] = useState('');
    const [isFetching, setIsFetching] = useState(false);
    const [expiryByNumber, setExpiryByNumber] = useState(() => {
        try {
            const stored = localStorage.getItem(G9_EXPIRY_BY_NUMBER_KEY);
            const parsed = stored ? JSON.parse(stored) : {};
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (error) {
            return {};
        }
    });
    const pendingExpiryFetches = useRef(new Set());
    const lastExpiryFetchAt = useRef({});
    const initialExpirySweepDone = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [callStatusFilter, setCallStatusFilter] = useState(() => {
        try {
            const stored = localStorage.getItem(G9_CALL_STATUS_FILTER_KEY);
            return stored || 'all';
        } catch (error) {
            return 'all';
        }
    });
    const [visibleColumns, setVisibleColumns] = useState(() => {
        try {
            const stored = localStorage.getItem(G9_VISIBLE_COLUMNS_KEY);
            if (!stored) return G9_DEFAULT_VISIBLE_COLUMNS;
            const parsed = JSON.parse(stored);
            const parsedObj = parsed && typeof parsed === 'object' ? parsed : {};
            const legacyActions = parsedObj.actions;
            return {
                ...G9_DEFAULT_VISIBLE_COLUMNS,
                ...parsedObj,
                actionSelect: parsedObj.actionSelect ?? legacyActions ?? G9_DEFAULT_VISIBLE_COLUMNS.actionSelect,
                actionReboot: parsedObj.actionReboot ?? legacyActions ?? G9_DEFAULT_VISIBLE_COLUMNS.actionReboot,
            };
        } catch (error) {
            return G9_DEFAULT_VISIBLE_COLUMNS;
        }
    });
    const [checklistDialogOpen, setChecklistDialogOpen] = useState(false);
    const [checklistLoading, setChecklistLoading] = useState(false);
    const [checklistSaving, setChecklistSaving] = useState(false);
    const [checklistError, setChecklistError] = useState('');
    const [columnDialogOpen, setColumnDialogOpen] = useState(false);
    const [selectedChecklistValues, setSelectedChecklistValues] = useState([]);
    const [selectedOperation, setSelectedOperation] = useState('change-imei');
    const [selectedSipOption, setSelectedSipOption] = useState('-0');
    const [updatedPorts, setUpdatedPorts] = useState(() => {
        try {
            const stored = localStorage.getItem(G9_UPDATED_PORTS_KEY);
            const parsed = stored ? JSON.parse(stored) : [];
            if (!Array.isArray(parsed)) {
                return [];
            }
            return parsed
                .map((item) => Number(item))
                .filter((port) => Number.isInteger(port) && port >= 1 && port <= 32);
        } catch (error) {
            return [];
        }
    });
    const [bulkSelectedPorts, setBulkSelectedPorts] = useState([]);
    const hasInitializedPortSelection = useRef(false);
    const isMobile = useMediaQuery('(max-width:900px)');

    // 1) Create a dark theme
    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            background: {
                default: '#121212',
                paper: '#1e1e1e',
            },
            text: {
                primary: '#ffffff',
            },
            primary: {
                main: '#90caf9',
            },
            error: {
                main: '#f44336',
            },
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            setIsFetching(true);
            try {
                // Fetch data sequentially
                const allNumbersResponse = await fetch('https://frek.cc/proxy/38.54.86.24:5070/fetch-all-numbers');
                if (!allNumbersResponse.ok) throw new Error('Failed to fetch numbers');
                const allNumbersData = await allNumbersResponse.json();
                const normalizedNumbersData = Array.isArray(allNumbersData)
                    ? (() => {
                        // Shape: [["639..", ...], [["1.01", ...], ...]]
                        const nestedRowsArray = allNumbersData.find(
                            item => Array.isArray(item) && item.length > 0 && Array.isArray(item[0])
                        );
                        if (nestedRowsArray) {
                            return nestedRowsArray;
                        }

                        // Shape: [{ value: [["1.01", ...], ...], Count: ... }, ...]
                        const objectRowsArray = allNumbersData.find(
                            item => item && Array.isArray(item.value) && item.value.length > 0 && Array.isArray(item.value[0])
                        );
                        if (objectRowsArray) {
                            return objectRowsArray.value;
                        }

                        // Shape: [["1.01", ...], ...]
                        if (
                            allNumbersData.length > 0 &&
                            Array.isArray(allNumbersData[0]) &&
                            typeof allNumbersData[0][0] === 'string'
                        ) {
                            return allNumbersData;
                        }

                        return [];
                    })()
                    : [];
                setData(normalizedNumbersData);

                const monitorResponse = await fetch('https://frek.cc/proxy/38.54.86.24:6687/monitor-call/g9');
                if (!monitorResponse.ok) throw new Error('Failed to fetch monitor data');
                const monitorDataData = await monitorResponse.json();
                setMonitorData(monitorDataData || []);

                const sipResponse = await fetch('https://frek.cc/proxy/38.54.86.24:6687/monitor-sip/g9');
                if (!sipResponse.ok) throw new Error('Failed to fetch SIP data');
                const sipDataData = await sipResponse.json();
                setSipData(sipDataData || []);

                const mediaResponse = await fetch('https://frek.cc/proxy/38.54.86.24:6687/monitor-media/g9');
                if (!mediaResponse.ok) throw new Error('Failed to fetch media data');
                const mediaDataData = await mediaResponse.json();
                setMediaData(mediaDataData || []);

                const portResponse = await fetch('https://frek.cc/proxy/38.54.86.24:6687/monitor-port/g9');
                if (!portResponse.ok) throw new Error('Failed to fetch port data');
                const portDataData = await portResponse.json();
                setPortData(portDataData || []);

                const smsStatusResponse = await fetch(`https://frek.cc/proxy/38.54.86.24:5080/fetch-api/goip${GOIP_NUMBER}-sms-status`);
                if (!smsStatusResponse.ok) throw new Error('Failed to fetch SMS status data');
                const smsStatusText = await smsStatusResponse.text();

                const regexList = [
                    /var strSmsStatList = '({.*?})';/ms,
                    /splitPortDataFormat\('({.*?})'/ms,
                ];

                let jsonString = null;
                for (const regex of regexList) {
                    const match = smsStatusText.match(regex);
                    if (match && match[1]) {
                        jsonString = match[1];
                        break;
                    }
                }

                if (!jsonString) {
                    throw new Error('SMS status data not found in the fetched string.');
                }

                jsonString = jsonString.replace(/\\"/g, '"');
                const smsJson = JSON.parse(jsonString);
                const smsRows = Array.isArray(smsJson?.data)
                    ? smsJson.data.filter((entry) => entry?.[1] !== 'Total')
                    : [];

                const smsByPort = smsRows.reduce((acc, entry) => {
                    const rawPort = String(entry?.[1] ?? '').trim();
                    const basePort = rawPort.split('.')[0];
                    if (basePort) {
                        acc[basePort] = entry;
                    }
                    return acc;
                }, {});
                setSmsStatusByPort(smsByPort);

            } catch (error) {
                console.warn("One or more data sources failed to load. This may be temporary.", error);
            } finally {
                setIsFetching(false);
            }
        };

        fetchData();
        const intervalId = setInterval(fetchData, 5000); // Fetch every 10 seconds
        return () => clearInterval(intervalId); // Cleanup interval
    }, []);
    useEffect(() => {
        document.title = 'G9 Ports Manager';
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem(G9_CALL_STATUS_FILTER_KEY, callStatusFilter);
        } catch (error) {
            // Ignore storage failures (private mode/storage restrictions).
        }
    }, [callStatusFilter]);

    useEffect(() => {
        try {
            localStorage.setItem(G9_VISIBLE_COLUMNS_KEY, JSON.stringify(visibleColumns));
        } catch (error) {
            // Ignore storage failures (private mode/storage restrictions).
        }
    }, [visibleColumns]);

    useEffect(() => {
        try {
            localStorage.setItem(G9_EXPIRY_BY_NUMBER_KEY, JSON.stringify(expiryByNumber));
        } catch (error) {
            // Ignore storage failures.
        }
    }, [expiryByNumber]);

    useEffect(() => {
        try {
            localStorage.setItem(
                G9_UPDATED_PORTS_KEY,
                JSON.stringify(
                    updatedPorts
                        .slice()
                        .sort((a, b) => a - b)
                )
            );
        } catch (error) {
            // Ignore storage failures.
        }
    }, [updatedPorts]);

    useEffect(() => {
        if (!checklistDialogOpen) {
            return;
        }

        const fetchChecklist = async () => {
            setChecklistLoading(true);
            setChecklistError('');
            try {
                const response = await fetch(G9_OPENER_URL, { method: 'GET' });
                if (!response.ok) {
                    throw new Error(`Request failed with status ${response.status}`);
                }
                const result = await response.json();
                const rawValue = Array.isArray(result) && result[0] && result[0].value ? result[0].value : '';
                const parsedValues = String(rawValue)
                    .split(',')
                    .map((item) => item.trim())
                    .filter((value) => value !== '' && G9_CHECKLIST_GROUPS.some((group) => group.value === value));
                setSelectedChecklistValues(parsedValues);
            } catch (error) {
                setChecklistError('Failed to load checklist values.');
            } finally {
                setChecklistLoading(false);
            }
        };

        fetchChecklist();
    }, [checklistDialogOpen]);

    const runWithPending = (label, requestFn) => {
        setPendingAction(label);
        return requestFn().finally(() => setPendingAction(''));
    };

    const handleNotification = (message, severity = 'success') => {
        showNotification(message, severity);
    };

    const openChecklistDialog = () => setChecklistDialogOpen(true);
    const closeChecklistDialog = () => setChecklistDialogOpen(false);
    const openColumnDialog = () => setColumnDialogOpen(true);
    const closeColumnDialog = () => setColumnDialogOpen(false);

    const toggleChecklistValue = (value) => {
        setSelectedChecklistValues((prevValues) => {
            if (prevValues.includes(value)) {
                return prevValues.filter((item) => item !== value);
            }
            return [...prevValues, value];
        });
    };

    const handleSaveChecklist = async () => {
        setChecklistSaving(true);
        setChecklistError('');
        try {
            const payload = {
                value: selectedChecklistValues
                    .slice()
                    .sort((a, b) => Number(a) - Number(b))
                    .join(','),
            };
            const response = await fetch(G9_OPENER_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            closeChecklistDialog();
            handleNotification('Goip opener saved.');
        } catch (error) {
            setChecklistError('Failed to save checklist values.');
        } finally {
            setChecklistSaving(false);
        }
    };

    const executeImeiSmsOperation = () =>
        runWithPending(`Exec ${selectedOperation}`, async () => {
            const gatewayId = 'g9';
            let url = '';
            let method = 'GET';
            let body;
            let headers;

            if (selectedOperation === 'send-ussd') {
                url = `https://frek.cc/proxy/38.54.86.24:6687/send-ussd/${gatewayId}`;
                method = 'POST';
                headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
                body = JSON.stringify({
                    command: 'send',
                    target: 'goip_ussd',
                    ports: Array.from({ length: 32 }, (_, i) => i + 1).join(','),
                    ussd_cmd: Array(32).fill('*123#').join(','),
                    goip_show_all: 0,
                });
            } else if (selectedOperation === 'update-cookie') {
                url = `https://frek.cc/proxy/38.54.86.24:6687/update-local-cookies/${gatewayId}`;
            } else if (selectedOperation === 'save-config') {
                url = `https://frek.cc/proxy/38.54.86.24:6687/save/${gatewayId}`;
                method = 'POST';
            } else if (selectedOperation === 'reboot-gateway') {
                url = `https://frek.cc/proxy/38.54.86.24:6687/reboot/${gatewayId}`;
                method = 'POST';
            } else if (selectedOperation === 'change-imei' || selectedOperation === 'change-imei-no-sim') {
                url = `https://frek.cc/proxy/38.54.86.24:6687/${selectedOperation}/${gatewayId}`;
            } else {
                url = `https://frek.cc/proxy/38.54.86.24:6687/${selectedOperation}/${gatewayId}`;
            }

            const response = await fetch(url, { method, headers, body });
            const contentType = response.headers.get('content-type') || '';
            const result = contentType.includes('application/json')
                ? await response.json()
                : await response.text();

            const message =
                typeof result === 'string'
                    ? result
                    : result?.message || result?.error || JSON.stringify(result);

            if (!response.ok) {
                throw new Error(message || `HTTP ${response.status}`);
            }

            handleNotification(`Response: ${message}`, 'success');
        }).catch((error) => {
            handleNotification(`Failed: ${error.message}`, 'error');
        });

    const applySipOption = () =>
        runWithPending(`Apply SIP ${selectedSipOption}`, async () => {
            const response = await fetch(`https://frek.cc/proxy/38.54.86.24:6687/configure-sip/g9/${selectedSipOption}`, {
                method: 'GET',
            });
            const result = await response.text();
            if (!response.ok) {
                throw new Error(result || `HTTP ${response.status}`);
            }
            handleNotification(`Response: ${result}`, 'success');
        }).catch((error) => {
            handleNotification(`Failed: ${error.message}`, 'error');
        });

    const resetPorts = () => runWithPending('Reset All Ports', () => fetch('https://frek.cc/proxy/38.54.86.24:5070/reset-ports', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'reset' }),
    })
        .then(response => response.json())
        .then(responseData => handleNotification(responseData.message || 'Ports reset successfully.'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to reset ports.', 'error');
        }));

    const changeIMEI = () => runWithPending('Change IMEI', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/change-imei/g9', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('IMEI Changing Success') ? 'IMEI successfully changed.' : 'Failed to change IMEI.', text.includes('IMEI Changing Success') ? 'success' : 'warning'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to change IMEI.', 'error');
        }));

    const saveSettings = () => runWithPending('Save Settings', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/save/g9', {
        method: 'POST',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'Settings saved successfully.' : 'Failed to save settings.', text.includes('success') ? 'success' : 'warning'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to save settings.', 'error');
        }));

    const rebootGateway = () => runWithPending('Reboot Gateway', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/reboot/g9', {
        method: 'POST',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'Gateway rebooted successfully.' : 'Failed to reboot gateway.', text.includes('success') ? 'success' : 'warning'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to reboot gateway.', 'error');
        }));

    const disableSms = () => runWithPending('Disable SMS', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/disable-sms/g9', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'Gateway disable SMS successfully.' : 'Failed to disable gateway SMS.', text.includes('success') ? 'success' : 'warning'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to disable gateway SMS.', 'error');
        }));

    const enableSms = () => runWithPending('Enable SMS', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/enable-sms/g9', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'Gateway enable SMS successfully.' : 'Failed to enable gateway SMS.', text.includes('success') ? 'success' : 'warning'))
        .catch(error => {
            console.error('Error:', error);
            handleNotification('Failed to enable gateway SMS.', 'error');
        }));

    const ncliOn = () => runWithPending('NCLI On', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/configure-sip/g9/1', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'NCLI ON Success.' : 'NCLI ON Failed.', text.includes('success') ? 'success' : 'warning'))
        .catch(() => handleNotification('NCLI ON Failed.', 'error')));

    const ncliAccount = () => runWithPending('NCLI Account', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/configure-sip/g9/1a', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'NCLI ACCOUNT Success.' : 'NCLI ACCOUNT Failed.', text.includes('success') ? 'success' : 'warning'))
        .catch(() => handleNotification('NCLI ACCOUNT Failed.', 'error')));

    const offTraffic = () => runWithPending('Off Traffic', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/configure-sip/g9/-0', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'OFF TRAFFIC Success.' : 'OFF TRAFFIC Failed.', text.includes('success') ? 'success' : 'warning'))
        .catch(() => handleNotification('OFF TRAFFIC Failed.', 'error')));

    const emptyAccount = () => runWithPending('Empty Account', () => fetch('https://frek.cc/proxy/38.54.86.24:6687/configure-sip/g9/0', {
        method: 'GET',
    })
        .then(response => response.text())
        .then(text => handleNotification(text.includes('success') ? 'EMPTY ACCOUNT Success.' : 'EMPTY ACCOUNT Failed.', text.includes('success') ? 'success' : 'warning'))
        .catch(() => handleNotification('EMPTY ACCOUNT Failed.', 'error')));

    const handleUpdatedPortCheckbox = (port) => {
        setUpdatedPorts((prevSelected) => {
            if (prevSelected.includes(port)) {
                return prevSelected.filter((p) => p !== port);
            }
            return [...prevSelected, port];
        });
    };

    const handleBulkPortCheckbox = (port) => {
        setBulkSelectedPorts((prevSelected) => {
            if (prevSelected.includes(port)) {
                return prevSelected.filter((p) => p !== port);
            }
            return [...prevSelected, port];
        });
    };

    const handleSelectAllUpdatedPorts = (checked) => {
        if (checked) {
            setUpdatedPorts(Array.from({ length: 32 }, (_, idx) => idx + 1));
            return;
        }
        setUpdatedPorts([]);
    };

    const handleSelectAllBulkPorts = (checked) => {
        if (checked) {
            setBulkSelectedPorts(Array.from({ length: 32 }, (_, idx) => idx + 1));
            return;
        }
        setBulkSelectedPorts([]);
    };

    const [bulkTargetSlot, setBulkTargetSlot] = useState(1);

    // 🔁 Bulk switch selected base ports to a target slot (ONE CALL)
    const bulkSwitchSelectedPorts = (targetSlot) =>
        runWithPending(`Bulk Switch → Slot ${targetSlot}`, async () => {
            if (!bulkSelectedPorts.length) {
                handleNotification('No ports selected.', 'warning');
                return;
            }

            const slotByBasePort = {};
            data.forEach((entry) => {
                const rawPort = String(entry?.[0] ?? '').trim();
                if (!rawPort) return;
                const [baseRaw, slotRaw] = rawPort.split('.');
                const base = Number(baseRaw);
                const slot = Number(slotRaw);
                if (Number.isInteger(base) && base >= 1 && base <= 32 && Number.isInteger(slot) && slot >= 1 && slot <= 16) {
                    slotByBasePort[base] = slot;
                }
            });
            const toSlotMask = (slot) => {
                const safeSlot = Math.max(1, Math.min(16, Number(slot) || 1));
                const mask = Array(16).fill('0');
                mask[safeSlot - 1] = '1';
                return mask.join('');
            };

            const payload = {
                goip_cmd_port: '',
                btn_goip_port_hwattr: 'Submit',
            };

            for (let i = 1; i <= 32; i += 1) {
                const isUpdated = updatedPorts.includes(i);
                const isBulkSelected = bulkSelectedPorts.includes(i);
                const currentSlot = slotByBasePort[i] || 1;
                const nextSlot = isBulkSelected ? targetSlot : currentSlot;
                payload[`port_enable(${i})`] = isUpdated ? 'on' : 'off';
                payload[`goip_slot_selected(${i})`] = toSlotMask(nextSlot);
                payload[`goip_lockTheOperator(${i})`] = '0';
                payload[`input_vol(${i})`] = '0';
                payload[`output_vol(${i})`] = '12';
                payload[`balance(${i})`] = '0.00';
                payload[`tel_hot(${i})`] = '';
                payload[`unnum(${i})`] = '';
                payload[`busynum(${i})`] = '';
                payload[`nonum(${i})`] = '';
            }

            const response = await fetch(G9_UPDATE_PORTS_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const contentType = response.headers.get('content-type') || '';
            const result = contentType.includes('application/json')
                ? await response.json()
                : await response.text();
            const message =
                typeof result === 'string'
                    ? result
                    : result?.message || result?.error || JSON.stringify(result);

            if (!response.ok) {
                throw new Error(message || `HTTP ${response.status}`);
            }

            handleNotification(`Switched ${bulkSelectedPorts.length} port(s) to slot ${targetSlot}`);
        }).catch((error) => {
            handleNotification(`Bulk switch failed: ${error.message}`, 'error');
        });

    const updatePortsConfiguration = () =>
        runWithPending('Update Ports', async () => {
            const slotByBasePort = {};
            data.forEach((entry) => {
                const rawPort = String(entry?.[0] ?? '').trim();
                if (!rawPort) return;
                const [baseRaw, slotRaw] = rawPort.split('.');
                const base = Number(baseRaw);
                const slot = Number(slotRaw);
                if (Number.isInteger(base) && base >= 1 && base <= 32 && Number.isInteger(slot) && slot >= 1 && slot <= 16) {
                    slotByBasePort[base] = slot;
                }
            });
            const toSlotMask = (slot) => {
                const safeSlot = Math.max(1, Math.min(16, Number(slot) || 1));
                const mask = Array(16).fill('0');
                mask[safeSlot - 1] = '1';
                return mask.join('');
            };

            const payload = {
                goip_cmd_port: '',
                btn_goip_port_hwattr: 'Submit',
            };
            for (let i = 1; i <= 32; i += 1) {
                const isSelected = updatedPorts.includes(i);
                const currentSlot = slotByBasePort[i] || 1;
                payload[`port_enable(${i})`] = isSelected ? 'on' : 'off';
                payload[`goip_slot_selected(${i})`] = toSlotMask(currentSlot);
                payload[`goip_lockTheOperator(${i})`] = '0';
                payload[`input_vol(${i})`] = '0';
                payload[`output_vol(${i})`] = '12';
                payload[`balance(${i})`] = '0.00';
                payload[`tel_hot(${i})`] = '';
                payload[`unnum(${i})`] = '';
                payload[`busynum(${i})`] = '';
                payload[`nonum(${i})`] = '';
            }

            const response = await fetch(G9_UPDATE_PORTS_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const contentType = response.headers.get('content-type') || '';
            const result = contentType.includes('application/json')
                ? await response.json()
                : await response.text();
            const message =
                typeof result === 'string'
                    ? result
                    : result?.message || result?.error || JSON.stringify(result);

            if (!response.ok) {
                throw new Error(message || `HTTP ${response.status}`);
            }

            handleNotification(`Ports updated: ${message || 'Success'}`);
        }).catch((error) => {
            handleNotification(`Failed to update ports: ${error.message}`, 'error');
        });

    const rebootSinglePort = (basePort) =>
        runWithPending(`Reboot Port ${basePort}`, async () => {
            const slotByBasePort = {};
            data.forEach((entry) => {
                const rawPort = String(entry?.[0] ?? '').trim();
                if (!rawPort) return;
                const [baseRaw, slotRaw] = rawPort.split('.');
                const base = Number(baseRaw);
                const slot = Number(slotRaw);
                if (Number.isInteger(base) && base >= 1 && base <= 32 && Number.isInteger(slot) && slot >= 1 && slot <= 16) {
                    slotByBasePort[base] = slot;
                }
            });
            const toSlotMask = (slot) => {
                const safeSlot = Math.max(1, Math.min(16, Number(slot) || 1));
                const mask = Array(16).fill('0');
                mask[safeSlot - 1] = '1';
                return mask.join('');
            };

            const payload = {
                command: 'restart',
                goip_cmd_port: String(basePort),
                btn_goip_port_hwattr: 'Submit',
            };

            for (let i = 1; i <= 32; i += 1) {
                const isSelected = updatedPorts.includes(i);
                const currentSlot = slotByBasePort[i] || 1;
                payload[`port_enable(${i})`] = isSelected ? 'on' : 'off';
                payload[`goip_slot_selected(${i})`] = toSlotMask(currentSlot);
                payload[`goip_lockTheOperator(${i})`] = '0';
                payload[`input_vol(${i})`] = '0';
                payload[`output_vol(${i})`] = '12';
                payload[`balance(${i})`] = '0.00';
                payload[`tel_hot(${i})`] = '';
                payload[`unnum(${i})`] = '';
                payload[`busynum(${i})`] = '';
                payload[`nonum(${i})`] = '';
            }

            const response = await fetch(G9_UPDATE_PORTS_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const contentType = response.headers.get('content-type') || '';
            const result = contentType.includes('application/json')
                ? await response.json()
                : await response.text();
            const message =
                typeof result === 'string'
                    ? result
                    : result?.message || result?.error || JSON.stringify(result);

            if (!response.ok) {
                throw new Error(message || `HTTP ${response.status}`);
            }

            handleNotification(`Rebooted port ${basePort}: ${message || 'Success'}`);
        }).catch((error) => {
            handleNotification(`Failed to reboot port ${basePort}: ${error.message}`, 'error');
        });

    const confirmAction = (action, actionLabel, description) => {
        setActionToConfirm(() => action);
        setActiveActionLabel(actionLabel || 'Action');
        setConfirmDialogTitle(`Confirm: ${actionLabel || 'Action'}`);
        setConfirmDialogMessage(description || 'Are you sure you want to proceed with this action?');
        setConfirmDialogOpen(true);
    };

    const handleConfirm = () => {
        if (actionToConfirm) actionToConfirm();
        setConfirmDialogOpen(false);
    };

    const handleCancel = () => {
        setConfirmDialogOpen(false);
        setActionToConfirm(null);
        setActiveActionLabel('');
    };

    const toNumber = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    };

    const getTimeDifferenceInSeconds = (timestamp) => {
        if (!timestamp || Number.isNaN(new Date(timestamp).getTime())) return -1;
        const now = new Date();
        const expiryDate = new Date(timestamp);
        return Math.floor((expiryDate - now) / 1000);
    };

    const formatTimeDifference = (timestamp) => {
        if (!timestamp || Number.isNaN(new Date(timestamp).getTime())) {
            return '-';
        }

        const inputDate = new Date(timestamp);
        const bannedDateParts = '1970-01-01 13:00:00'.split(/[- :]/);
        const bannedDate = new Date(
            bannedDateParts[0],
            bannedDateParts[1] - 1,
            bannedDateParts[2],
            bannedDateParts[3],
            bannedDateParts[4],
            bannedDateParts[5]
        );

        if (inputDate.getTime() === bannedDate.getTime()) {
            return 'Ban';
        }

        let diffInSeconds = Math.floor((inputDate - new Date()) / 1000);
        if (diffInSeconds <= 0) {
            return 'Exp';
        }

        const days = Math.floor(diffInSeconds / (3600 * 24));
        diffInSeconds %= (3600 * 24);
        const hours = Math.floor(diffInSeconds / 3600);
        diffInSeconds %= 3600;
        const minutes = Math.floor(diffInSeconds / 60);
        const seconds = diffInSeconds % 60;

        if (days > 0) return hours > 0 ? `${days}d ${hours}h` : minutes > 0 ? `${days}d ${minutes}m` : `${days}d ${seconds}s`;
        if (hours > 0) return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h ${seconds}s`;
        if (minutes > 0) return `${minutes}m ${seconds}s`;
        return `${seconds}s`;
    };

    const fetchExpiryForSim = async (sim) => {
        const endpoint = `https://frek.cc/proxy/38.54.86.24:5000/expiry/${encodeURIComponent(sim)}`;
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': 'uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3',
            },
        });
        if (!response.ok) return null;
        const result = await response.json();
        const timestamp = result?.[0]?.value;
        return timestamp && !Number.isNaN(new Date(timestamp).getTime()) ? timestamp : null;
    };

    const getBalTextForNumber = (number) => {
        const key = String(number || '').trim();
        if (!key) return '-';
        return formatTimeDifference(expiryByNumber[key]);
    };

    const getBalTooltipForNumber = (number) => {
        const key = String(number || '').trim();
        if (!key) return 'No number';
        const expiryTimestamp = expiryByNumber[key];
        if (!expiryTimestamp) return 'Fetching expiry...';
        if (Number.isNaN(new Date(expiryTimestamp).getTime())) return 'Invalid expiry data';
        const remainingText = formatTimeDifference(expiryTimestamp);
        return `${new Date(expiryTimestamp).toLocaleString()} | Remaining: ${remainingText}`;
    };

    const getRowHealth = (monitorEntry) => {
        const callStatus = String(monitorEntry['Call-Status'] || '').toLowerCase();
        const reason = String(monitorEntry.Reason || '').toLowerCase();
        const conFail = toNumber(monitorEntry.ConFail);
        const calls = toNumber(monitorEntry.Calls);
        const connected = toNumber(monitorEntry.Connected);
        if (conFail > 0 || /fail|error|busy|reject|forbidden/.test(reason) || /fail|error/.test(callStatus)) return 'failed';
        if (connected > 0 || /connected|answer|talk/.test(callStatus)) return 'connected';
        if (calls > 0) return 'warning';
        return 'idle';
    };

    const getRowColor = () => 'transparent';

    const shouldDisplayRow = (row) => {
        const search = searchQuery.trim().toLowerCase();
        const reason = String(row.monitorEntry.Reason || '').toLowerCase();
        const callStatus = String(row.monitorEntry['Call-Status'] || '').trim().toLowerCase();
        const numberText = String(row.number || '').toLowerCase();
        const portText = String(row.portNumber).toLowerCase();
        const matchesSearch = !search || portText.includes(search) || numberText.includes(search) || reason.includes(search) || callStatus.includes(search);
        const matchesCallStatus = callStatusFilter === 'all' || callStatus === callStatusFilter;
        return matchesSearch && matchesCallStatus;
    };

    const callStatusOptions = useMemo(() => {
        const unique = new Map();
        monitorData.forEach((entry) => {
            const raw = String(entry?.['Call-Status'] || '').trim();
            if (!raw) return;
            const normalized = raw.toLowerCase();
            if (!unique.has(normalized)) {
                unique.set(normalized, raw);
            }
        });
        const dynamicOptions = Array.from(unique.entries())
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map(([value, label]) => ({ value, label }));

        const fixedOptions = [
            { value: 'connected', label: 'CONNECTED: \u2714' },
            { value: 'hangup', label: 'HANGUP: \u2715' },
            { value: 'alerting', label: 'ALERTING: \u27f9' },
            { value: 'disconnected', label: 'DISCONNECTED: \u2605' },
            { value: 'dialing', label: 'DIALING: \u25ba' },
        ];

        const seen = new Set(fixedOptions.map((item) => item.value));
        const extraOptions = dynamicOptions.filter((item) => !seen.has(item.value));
        return [...fixedOptions, ...extraOptions];
    }, [monitorData]);

    const metricColumns = useMemo(
        () => [
            { label: 'D', key: 'Calls' },
            { label: 'A', key: 'Alerted' },
            { label: 'C', key: 'Connected' },
            { label: 'CF', key: 'ConFail' },
            { label: 'ACD', key: 'ACD' },
            { label: 'ASR', key: 'ASR' },
        ],
        []
    );

    const statusMapping = {
        CONNECTED: '\u2714',
        HANGUP: '\u2715',
        ALERTING: '\u27f9',
        DISCONNECTED: '\u2605',
        DIALING: '\u25ba',
    };

    const metricWidths = useMemo(
        () =>
            metricColumns.map(({ label, key }) => {
                const maxDataLen = monitorData.reduce((maxLen, stat) => {
                    const raw = stat?.[key];
                    const value = raw === 0 ? '0' : raw || '-';
                    return Math.max(maxLen, String(value).length);
                }, 1);
                return Math.max(label.length, maxDataLen);
            }),
        [metricColumns, monitorData]
    );

    const formatMetricLine = (stat, isHeader = false) =>
        metricColumns
            .map((column, idx) => {
                const raw = isHeader ? column.label : stat?.[column.key];
                const value = raw === 0 ? '0' : raw || '-';
                return String(value).padStart(metricWidths[idx], ' ');
            })
            .join(' | ');

    const formatMetricLineWithSms = (row, isHeader = false) => {
        const baseLine = formatMetricLine(isHeader ? null : row?.monitorEntry, isHeader);
        if (isHeader) {
            return `${baseLine} | SNT | FS`;
        }
        const snt = row?.smsSnt ?? '-';
        const fs = row?.smsFs ?? '-';
        return `${baseLine} | ${String(snt).padStart(3, ' ')} | ${String(fs).padStart(2, ' ')}`;
    };

    const renderMetricLineWithSms = (row) => {
        const baseLine = formatMetricLine(row?.monitorEntry, false);
        const snt = row?.smsSnt ?? '-';
        const fs = row?.smsFs ?? '-';
        const fsNumber = Number(fs);
        const shouldHighlightFs = Number.isFinite(fsNumber) && fsNumber > 1;
        return (
            <>
                {`${baseLine} | ${String(snt).padStart(3, ' ')} | `}
                <Box component="span" sx={{ color: shouldHighlightFs ? '#f44336' : 'inherit', fontWeight: shouldHighlightFs ? 700 : 400 }}>
                    {String(fs).padStart(2, ' ')}
                </Box>
            </>
        );
    };

    const getBaseContext = (basePort) => {
        const activeEntry = data.find(
            item => Array.isArray(item) && typeof item[0] === 'string' && item[0].split('.')[0] === basePort
        ) || [];
        const activePort = activeEntry[0] || `${basePort}.01`;
        const activePortParts = String(activePort).split('.');
        const activeSlot = Number(activePortParts[1]) || 1;
        return {
            basePort,
            activeEntry,
            activePort,
            activeSlot: Math.max(1, Math.min(16, activeSlot)),
            activeNumber: activeEntry[1] || '',
            sipEntry: sipData.find(item => item.Port && item.Port.toString() === basePort) || {},
            portEntry: portData.find(item => item.Port && item.Port.toString() === basePort) || {},
        };
    };

    const baseRows = (() => {
        const rows = [];
        for (let base = 1; base <= 32; base += 1) {
            const basePort = String(base);
            const ctx = getBaseContext(basePort);
            const monitorEntry = monitorData.find(item => item.Port === ctx.activePort) || {};
            const health = getRowHealth(monitorEntry);
            const row = {
                basePort,
                activePort: ctx.activePort,
                activeSlot: ctx.activeSlot,
                account: ctx.sipEntry.Account || 'N/A',
                sipStatus: ctx.sipEntry.Status || 'Unknown',
                portStatus: ctx.portEntry.Status || 'Unknown',
                smsFs: Number(smsStatusByPort[basePort]?.[7]) || 0,
                smsSnt: Number(smsStatusByPort[basePort]?.[5]) || 0,
                portNumber: ctx.activePort,
                number: ctx.activeNumber,
                monitorEntry,
                health,
            };
            if (shouldDisplayRow(row)) {
                rows.push(row);
            }
        }
        return rows;
    })();

    useEffect(() => {
        const sims = Array.from(
            new Set(
                baseRows
                    .map((row) => String(row.number || '').trim())
                    .filter((sim) => sim && sim.toLowerCase() !== 'n/a')
            )
        );
        if (sims.length === 0) return;

        const now = Date.now();
        const isInitialSweep = !initialExpirySweepDone.current;
        const allowExpiredRetries = Boolean(visibleColumns.autoRefetchExpiredBal) || isInitialSweep;
        sims.forEach((sim) => {
            const cachedTimestamp = expiryByNumber[sim];
            const hasValidTimestamp = Boolean(cachedTimestamp) && !Number.isNaN(new Date(cachedTimestamp).getTime());
            const timeLeft = hasValidTimestamp ? getTimeDifferenceInSeconds(cachedTimestamp) : -1;
            const isExpired = hasValidTimestamp && timeLeft <= 0;
            const isMissing = !hasValidTimestamp;
            const needsFetch = (isMissing && isInitialSweep) || (isExpired && allowExpiredRetries);
            const lastAttempt = lastExpiryFetchAt.current[sim] || 0;
            const isCooldown = (now - lastAttempt) < G9_EXPIRY_RETRY_MS;

            if (!needsFetch || isCooldown || pendingExpiryFetches.current.has(sim)) {
                return;
            }

            lastExpiryFetchAt.current[sim] = now;
            pendingExpiryFetches.current.add(sim);
            fetchExpiryForSim(sim)
                .then((timestamp) => {
                    setExpiryByNumber((prev) => {
                        const next = { ...prev };
                        if (timestamp) {
                            next[sim] = timestamp;
                        } else {
                            delete next[sim];
                        }
                        return next;
                    });
                })
                .finally(() => {
                    pendingExpiryFetches.current.delete(sim);
                });
        });
        if (isInitialSweep) {
            initialExpirySweepDone.current = true;
        }
    }, [baseRows, expiryByNumber, visibleColumns.autoRefetchExpiredBal]);

    useEffect(() => {
        if (hasInitializedPortSelection.current || monitorData.length === 0) {
            return;
        }

        const blockedBasePorts = Array.from(
            new Set(
                monitorData
                    .filter((entry) => String(entry?.Description || '').toLowerCase().includes('blocked by user'))
                    .map((entry) => Number(String(entry?.Port || '').split('.')[0]))
                    .filter((port) => Number.isInteger(port) && port >= 1 && port <= 32)
            )
        );

        setUpdatedPorts((prevSelected) => (prevSelected.length ? prevSelected : blockedBasePorts));
        setBulkSelectedPorts([]);
        hasInitializedPortSelection.current = true;
    }, [monitorData]);

    const gatewaySummary = useMemo(() => {
        const activeMonitorEntries = [];
        for (let base = 1; base <= 32; base += 1) {
            const ctx = getBaseContext(String(base));
            const monitorEntry = monitorData.find((item) => item.Port === ctx.activePort) || {};
            activeMonitorEntries.push(monitorEntry);
        }

        const totalCalls = activeMonitorEntries.reduce((sum, entry) => sum + toNumber(entry.Calls), 0);
        const totalAlerted = activeMonitorEntries.reduce((sum, entry) => sum + toNumber(entry.Alerted), 0);
        const totalFailures = activeMonitorEntries.reduce((sum, entry) => sum + toNumber(entry.ConFail), 0);
        const totalConnected = activeMonitorEntries.reduce((sum, entry) => sum + toNumber(entry.Connected), 0);
        const statusCounts = activeMonitorEntries.reduce(
            (acc, entry) => {
                const status = String(entry?.['Call-Status'] || '').trim().toUpperCase();
                if (status === 'DIALING') acc.dialing += 1;
                if (status === 'ALERTING') acc.alerting += 1;
                if (status === 'HANGUP') acc.hangup += 1;
                if (status === 'CONNECTED') acc.connected += 1;
                if (status === 'DISCONNECTED') acc.disconnected += 1;
                return acc;
            },
            { dialing: 0, alerting: 0, hangup: 0, connected: 0, disconnected: 0 }
        );
        const smsTotals = Object.values(smsStatusByPort).reduce(
            (acc, entry) => {
                acc.snt += toNumber(entry?.[5]);
                acc.fs += toNumber(entry?.[7]);
                return acc;
            },
            { snt: 0, fs: 0 }
        );
        return {
            totalCalls,
            totalAlerted,
            totalFailures,
            totalConnected,
            ...statusCounts,
            smsSntTotal: smsTotals.snt,
            smsFsTotal: smsTotals.fs,
        };
    }, [data, monitorData, portData, sipData, smsStatusByPort]);
    const isActionRunning = Boolean(pendingAction);
    const actionGroups = [
        {
            title: 'Gateway Actions',
            items: [
                { label: 'Reset All Ports', color: 'error', icon: RestartAltIcon, onClick: () => confirmAction(resetPorts, 'Reset All Ports', 'This sends a reset to all ports on gateway G9.') },
                { label: 'Update Ports', color: 'primary', icon: SaveIcon, onClick: () => confirmAction(updatePortsConfiguration, 'Update Ports', `Apply checked port states to G9 (${updatedPorts.length} selected).`) },
                { label: 'Goip Opener', color: 'info', icon: LockOpenIcon, onClick: openChecklistDialog },
                { label: 'Visible Columns', color: 'secondary', icon: ViewColumnIcon, onClick: openColumnDialog },
            ],
        },
    ];

    const renderActionButton = (item) => {
        const IconComp = item.icon;
        return (
            <Tooltip key={item.label} title={item.label} disableHoverListener={isMobile}>
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        width: isMobile ? '100%' : 'auto',
                    }}
                >
                    <IconButton
                        color={item.color}
                        disabled={isActionRunning}
                        onClick={item.onClick}
                        size={isMobile ? 'medium' : 'small'}
                        sx={{ border: '1px solid rgba(255,255,255,0.2)', borderRadius: 1.2 }}
                    >
                        <IconComp fontSize="small" />
                    </IconButton>
                    {pendingAction === item.label && (
                        <CircularProgress
                            size={22}
                            sx={{ position: 'absolute', top: -3, left: -3 }}
                        />
                    )}
                </Box>
            </Tooltip>
        );
    };

    const handleToggleColumn = (columnKey) => {
        setVisibleColumns((prev) => ({
            ...prev,
            [columnKey]: !prev[columnKey],
        }));
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Box sx={{ p: { xs: 1, md: 2 }, background: 'linear-gradient(180deg, #101217 0%, #0a0d11 100%)', minHeight: '100vh' }}>
                <Paper sx={{ p: 1.5, mb: 2, border: '1px solid rgba(255,255,255,0.08)' }}>
                    <Stack direction="column" spacing={1} alignItems="stretch">
                        <Stack
                            direction="row"
                            spacing={0.8}
                            flexWrap="wrap"
                            useFlexGap
                            justifyContent={{ xs: 'center', md: 'flex-start' }}
                            alignItems="center"
                            sx={{
                                '& .MuiChip-root': { height: { xs: 22, md: 24 } },
                                '& .MuiChip-label': { px: { xs: 0.8, md: 1 }, fontSize: { xs: 11, md: 12 } },
                            }}
                        >
                            {isFetching && <CircularProgress size={14} />}
                            <Chip label={`\u2714 ${gatewaySummary.connected}`} color="success" />
                            <Chip label={`\u25B6 ${gatewaySummary.dialing}`} color="info" />
                            <Chip label={`\u27F9 ${gatewaySummary.alerting}`} color="warning" />
                            <Chip label={`\u2715 ${gatewaySummary.hangup}`} color="error" />
                            <Chip label={`\u2605 ${gatewaySummary.disconnected}`} color="error" />
                            <Chip label={`D: ${gatewaySummary.totalCalls}`} color="primary" />
                            <Chip label={`A: ${gatewaySummary.totalAlerted}`} color="warning" />
                            <Chip label={`C: ${gatewaySummary.totalConnected}`} color="success" />
                            <Chip label={`CF: ${gatewaySummary.totalFailures}`} color={gatewaySummary.totalFailures > 0 ? 'error' : 'default'} />
                            <Chip label={`SNT: ${gatewaySummary.smsSntTotal}`} color={gatewaySummary.smsSntTotal > 0 ? 'warning' : 'default'} />
                            <Chip label={`FS: ${gatewaySummary.smsFsTotal}`} color={gatewaySummary.smsFsTotal > 1 ? 'error' : 'default'} />
                        </Stack>
                    </Stack>
                </Paper>

                <Paper sx={{ p: 1.5, mb: 2, border: '1px solid rgba(255,255,255,0.08)' }}>
                    <Stack direction="column" spacing={2} alignItems="stretch">
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{actionGroups[0]?.title || 'Gateway Actions'}</Typography>
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1, flexWrap: 'wrap' }}>
                                <Typography variant="caption">Bulk Switch → Slot</Typography>

                                <Select
                                    size="small"
                                    value={bulkTargetSlot}
                                    onChange={(e) => setBulkTargetSlot(Number(e.target.value))}
                                    sx={{ minWidth: 80 }}
                                >
                                    {Array.from({ length: 16 }, (_, i) => i + 1).map((slot) => (
                                        <MenuItem key={slot} value={slot}>
                                            Slot {slot}
                                        </MenuItem>
                                    ))}
                                </Select>

                                <Tooltip title={`Bulk switch ${bulkSelectedPorts.length} port(s) → Slot ${bulkTargetSlot}`}>
                                    <span>
                                        <IconButton
                                            size="small"
                                            color="warning"
                                            disabled={!bulkSelectedPorts.length || Boolean(pendingAction)}
                                            onClick={() =>
                                                confirmAction(
                                                    () => bulkSwitchSelectedPorts(bulkTargetSlot),
                                                    `Bulk Switch to Slot ${bulkTargetSlot}`,
                                                    `This will switch ${bulkSelectedPorts.length} selected base port(s) to slot ${bulkTargetSlot}. Continue?`
                                                )
                                            }
                                            sx={{ border: '1px solid rgba(255,255,255,0.25)', borderRadius: 1 }}
                                        >
                                            <SwapHorizIcon fontSize="small" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Stack>
                            {isMobile ? (
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(4, minmax(0, 52px))',
                                        gap: 0.75,
                                        justifyContent: 'flex-start',
                                    }}
                                >
                                    {(actionGroups[0]?.items || []).map(renderActionButton)}
                                </Box>
                            ) : (
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
                                    {(actionGroups[0]?.items || []).map(renderActionButton)}
                                </Stack>
                            )}
                        </Box>

                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: '1fr 1fr 1.2fr' },
                                gap: 2,
                                alignItems: 'start',
                            }}
                        >
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>SMS</Typography>
                                <Stack direction="row" spacing={0.75} alignItems="center">
                                    <Select
                                        size="small"
                                        value={selectedOperation}
                                        onChange={(event) => setSelectedOperation(event.target.value)}
                                        fullWidth
                                        sx={{ minWidth: 0, flex: 1 }}
                                    >
                                        {G9_IMEI_SMS_OPERATIONS.map((operation) => (
                                            <MenuItem key={operation.key} value={operation.key}>
                                                {operation.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Tooltip title="Go">
                                        <span>
                                            <IconButton
                                                color="primary"
                                                onClick={executeImeiSmsOperation}
                                                disabled={isActionRunning}
                                                sx={{ border: '1px solid rgba(255,255,255,0.2)', borderRadius: 1.2 }}
                                            >
                                                <PlayArrowIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Stack>
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>SIP</Typography>
                                <Stack direction="row" spacing={0.75} alignItems="center">
                                    <Select
                                        size="small"
                                        value={selectedSipOption}
                                        onChange={(event) => setSelectedSipOption(event.target.value)}
                                        fullWidth
                                        sx={{ minWidth: 0, flex: 1 }}
                                    >
                                        {G9_SIP_OPTIONS.map((option) => (
                                            <MenuItem key={option.key} value={option.key}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Tooltip title="Go">
                                        <span>
                                            <IconButton
                                                color="primary"
                                                onClick={applySipOption}
                                                disabled={isActionRunning}
                                                sx={{ border: '1px solid rgba(255,255,255,0.2)', borderRadius: 1.2 }}
                                            >
                                                <PlayArrowIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Stack>
                            </Box>
                            <Box sx={{ minWidth: 0, gridColumn: { xs: '1 / -1', md: 'auto' } }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Filters</Typography>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        label="Search Port / Number / Status / Reason"
                                        value={searchQuery}
                                        onChange={(event) => setSearchQuery(event.target.value)}
                                    />
                                    <Select
                                        size="small"
                                        value={callStatusFilter}
                                        onChange={(event) => setCallStatusFilter(event.target.value)}
                                        sx={{ minWidth: { xs: '100%', sm: 180 } }}
                                    >
                                        <MenuItem value="all">Call Status: All</MenuItem>
                                        {callStatusOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Stack>
                            </Box>
                        </Box>
                    </Stack>
                </Paper>

                <Divider sx={{ mb: 1.5 }} />

                <Box id="tablesContainer">
                    <TableContainer component={Paper} sx={{ border: '1px solid rgba(255,255,255,0.08)' }}>
                        <Table
                            size="small"
                            sx={{
                                width: 'max-content',
                                minWidth: '100%',
                                '& th, & td': {
                                    py: 0,
                                    px: { xs: 0.55, md: 0.3 },
                                    lineHeight: 1,
                                    height: 22,
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow sx={{ '& th': { fontSize: 12, fontWeight: 700 } }}>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            position: 'sticky',
                                            left: 0,
                                            zIndex: 3,
                                            backgroundColor: 'background.paper',
                                            width: '6ch',
                                            minWidth: '6ch',
                                            maxWidth: '6ch',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        Port
                                    </TableCell>
                                    {visibleColumns.account && <TableCell align="center">Acc.</TableCell>}
                                    <TableCell align="center">Call</TableCell>
                                    {visibleColumns.number && <TableCell align="center">Num.</TableCell>}
                                    {visibleColumns.bal && <TableCell align="center">bal</TableCell>}
                                    {visibleColumns.time && <TableCell align="center">Time</TableCell>}
                                    {visibleColumns.description && <TableCell align="center">Desc.</TableCell>}
                                    {visibleColumns.metrics && (
                                        <TableCell align="center">
                                            <Tooltip title="D: Calls | A: Alerted | C: Connected | CF: Consecutive Failed Calls | ACD: Actual Call Duration | ASR: Answer Seizure Ratio | SNT | FS">
                                                <Box component="span" sx={{ fontFamily: 'Consolas, \"Courier New\", monospace', whiteSpace: 'pre', fontVariantNumeric: 'tabular-nums' }}>
                                                    {formatMetricLineWithSms(null, true)}
                                                </Box>
                                            </Tooltip>
                                        </TableCell>
                                    )}
                                    {visibleColumns.actionSelect && (
                                        <>
                                            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                <Stack direction="row" spacing={0.3} justifyContent="center" alignItems="center">
                                                    <Tooltip title="Select all updated ports">
                                                        <Checkbox
                                                            size="small"
                                                            checked={updatedPorts.length === 32}
                                                            indeterminate={updatedPorts.length > 0 && updatedPorts.length < 32}
                                                            onChange={(event) => handleSelectAllUpdatedPorts(event.target.checked)}
                                                            sx={{ p: 0.2 }}
                                                        />
                                                    </Tooltip>
                                                    <Box component="span">Upd</Box>
                                                    <Tooltip title="Select all bulk-switch ports">
                                                        <Checkbox
                                                            size="small"
                                                            checked={bulkSelectedPorts.length === 32}
                                                            indeterminate={bulkSelectedPorts.length > 0 && bulkSelectedPorts.length < 32}
                                                            onChange={(event) => handleSelectAllBulkPorts(event.target.checked)}
                                                            sx={{ p: 0.2 }}
                                                        />
                                                    </Tooltip>
                                                    <Box component="span">Bulk</Box>
                                                </Stack>
                                            </TableCell>
                                        </>
                                    )}
                                    {visibleColumns.actionReboot && (
                                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>Reboot</TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {baseRows.map((row) => (
                                    <TableRow key={row.portNumber} sx={{ '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)' } }}>
                                        <TableCell
                                            align="center"
                                            sx={{
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 2,
                                                backgroundColor: 'background.paper',
                                                width: '6ch',
                                                minWidth: '6ch',
                                                maxWidth: '6ch',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            <Box
                                                component="span"
                                                sx={{
                                                    fontFamily: 'monospace',
                                                    color: /ok|up|ready|\u221A/i.test(String(row.portStatus || ''))
                                                        ? '#4caf50'
                                                        : 'inherit',
                                                    fontWeight: /ok|up|ready|\u221A/i.test(String(row.portStatus || ''))
                                                        ? 700
                                                        : 400,
                                                }}
                                            >
                                                {row.activePort}
                                            </Box>
                                        </TableCell>
                                        {visibleColumns.account && (
                                            <TableCell align="center">
                                                <Tooltip title={`SIP: ${row.sipStatus || 'Unknown'}`}>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            color: /ready/i.test(String(row.sipStatus || '')) ? '#4caf50' : 'inherit',
                                                            fontWeight: /ready/i.test(String(row.sipStatus || '')) ? 700 : 400,
                                                        }}
                                                    >
                                                        {row.account}
                                                    </Box>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                        <TableCell align="center">
                                            <Tooltip title={`Call Status: ${row.monitorEntry['Call-Status'] || 'Idle'}`}>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        fontSize: 14,
                                                        fontWeight: 700,
                                                        color: row.health === 'connected' ? '#4caf50' : row.health === 'failed' ? '#f44336' : row.health === 'warning' ? '#ff9800' : 'inherit',
                                                    }}
                                                >
                                                    {statusMapping[row.monitorEntry['Call-Status']] || '-'}
                                                </Box>
                                            </Tooltip>
                                        </TableCell>
                                        {visibleColumns.number && (
                                            <TableCell align="center" sx={{ fontFamily: 'monospace' }}>
                                                {row.number || ''}
                                            </TableCell>
                                        )}
                                        {visibleColumns.bal && (
                                            <TableCell align="center">
                                                <Tooltip title={getBalTooltipForNumber(row.number)}>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontFamily: 'monospace',
                                                            color: getBalTextForNumber(row.number) === 'Exp' ? '#f44336' : 'inherit',
                                                            fontWeight: getBalTextForNumber(row.number) === 'Exp' ? 700 : 400,
                                                        }}
                                                    >
                                                        {getBalTextForNumber(row.number)}
                                                    </Box>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                        {visibleColumns.time && <TableCell align="center">{row.monitorEntry.Time || ''}</TableCell>}
                                        {visibleColumns.description && <TableCell align="center">{row.monitorEntry.Description || ''}</TableCell>}
                                        {visibleColumns.metrics && (
                                            <TableCell align="center">
                                                <Box component="span" sx={{ fontFamily: 'Consolas, \"Courier New\", monospace', whiteSpace: 'pre', fontVariantNumeric: 'tabular-nums', fontSize: 11 }}>
                                                    {renderMetricLineWithSms(row)}
                                                </Box>
                                            </TableCell>
                                        )}
                                        {visibleColumns.actionSelect && (
                                            <>
                                                <TableCell align="center">
                                                    <Stack direction="row" spacing={0.3} justifyContent="center" alignItems="center">
                                                        <Tooltip title="Updated state (used by Update/Reboot)">
                                                            <Checkbox
                                                                size="small"
                                                                checked={updatedPorts.includes(Number(row.basePort))}
                                                                onChange={() => handleUpdatedPortCheckbox(Number(row.basePort))}
                                                                sx={{ p: 0.15 }}
                                                            />
                                                        </Tooltip>
                                                        <Tooltip title="Bulk switch selection">
                                                            <Checkbox
                                                                size="small"
                                                                checked={bulkSelectedPorts.includes(Number(row.basePort))}
                                                                onChange={() => handleBulkPortCheckbox(Number(row.basePort))}
                                                                sx={{ p: 0.15 }}
                                                            />
                                                        </Tooltip>
                                                    </Stack>
                                                </TableCell>
                                            </>
                                        )}
                                        {visibleColumns.actionReboot && (
                                            <TableCell align="center">
                                                <Tooltip title={`Reboot port ${row.basePort}`}>
                                                    <span>
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            disabled={Boolean(pendingAction)}
                                                            sx={{ p: 0.2 }}
                                                            onClick={() =>
                                                                confirmAction(
                                                                    () => rebootSinglePort(row.basePort),
                                                                    `Reboot Port ${row.basePort}`,
                                                                    `Restart base port ${row.basePort} without using checkbox selection.`
                                                                )
                                                            }
                                                        >
                                                            <RestartAltIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                <Dialog
                    open={checklistDialogOpen}
                    onClose={closeChecklistDialog}
                    aria-labelledby="g9-checklist-dialog-title"
                    aria-describedby="g9-checklist-dialog-description"
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle id="g9-checklist-dialog-title">Goip Opener</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="g9-checklist-dialog-description">
                            Select which goip should be enabled.
                        </DialogContentText>
                        <Box sx={{ mt: 2 }}>
                            {checklistLoading ? (
                                <Typography variant="body2">Loading checklist values...</Typography>
                            ) : (
                                <List dense>
                                    {G9_CHECKLIST_GROUPS.map((group) => {
                                        const isChecked = selectedChecklistValues.includes(group.value);
                                        return (
                                            <ListItemButton
                                                key={group.key}
                                                onClick={() => toggleChecklistValue(group.value)}
                                                sx={{ borderRadius: 1 }}
                                            >
                                                <Checkbox checked={isChecked} tabIndex={-1} disableRipple />
                                                <ListItemText primary={group.label} />
                                            </ListItemButton>
                                        );
                                    })}
                                </List>
                            )}
                            {checklistError ? (
                                <Typography variant="body2" sx={{ color: '#ffb4b4', mt: 1 }}>
                                    {checklistError}
                                </Typography>
                            ) : null}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeChecklistDialog} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSaveChecklist}
                            color="primary"
                            disabled={checklistLoading || checklistSaving}
                        >
                            {checklistSaving ? 'Saving...' : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={columnDialogOpen}
                    onClose={closeColumnDialog}
                    aria-labelledby="g9-columns-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="g9-columns-dialog-title">Visible Columns</DialogTitle>
                    <DialogContent>
                        <FormGroup>
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.account} onChange={() => handleToggleColumn('account')} />}
                                label="Account"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.number} onChange={() => handleToggleColumn('number')} />}
                                label="Num."
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.bal} onChange={() => handleToggleColumn('bal')} />}
                                label="bal"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.autoRefetchExpiredBal} onChange={() => handleToggleColumn('autoRefetchExpiredBal')} />}
                                label="Auto Refetch Expired bal"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.description} onChange={() => handleToggleColumn('description')} />}
                                label="Desc."
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.metrics} onChange={() => handleToggleColumn('metrics')} />}
                                label="D | A | C | CF | ACD | ASR | SNT | FS"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.time} onChange={() => handleToggleColumn('time')} />}
                                label="Time"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.actionSelect} onChange={() => handleToggleColumn('actionSelect')} />}
                                label="Select"
                            />
                            <FormControlLabel
                                control={<Switch size="small" checked={visibleColumns.actionReboot} onChange={() => handleToggleColumn('actionReboot')} />}
                                label="Reboot"
                            />
                        </FormGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeColumnDialog} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={confirmDialogOpen}
                    onClose={handleCancel}
                    aria-labelledby="confirm-dialog-title"
                    aria-describedby="confirm-dialog-description"
                >
                    <DialogTitle id="confirm-dialog-title">{confirmDialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="confirm-dialog-description">
                            {confirmDialogMessage}
                        </DialogContentText>
                        {activeActionLabel && (
                            <Chip sx={{ mt: 1 }} size="small" label={`Pending: ${activeActionLabel}`} />
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancel} color="inherit">Cancel</Button>
                        <Button onClick={handleConfirm} color="error" autoFocus>Confirm</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </ThemeProvider>
    );
};

export default G9PortsBingo;



